export const HEADING_FONTS = [
  "Cinzel", "Cinzel Decorative", "Pirata One", "Grenze Gotisch", "UnifrakturMaguntia",
  "MedievalSharp", "Metamorphous", "Uncial Antiqua", "New Rocker", "IM Fell English SC", "Almendra",
];

export const BODY_FONTS = [
  "Outfit", "EB Garamond", "Cormorant Garamond", "Crimson Text", "Spectral", "Lora",
  "Manrope", "DM Sans", "Barlow", "Nunito Sans",
];

export const CONTENT_SCHEMA = [
  {
    group: "Navigation",
    fields: [
      ["nav.about", "About tab"],
      ["nav.events", "Events tab"],
      ["nav.links", "Links tab"],
      ["nav.chat", "Chat tab"],
      ["nav.enter", "Sign-in button"],
    ],
  },
  {
    group: "About",
    fields: [
      ["about.tagline", "Tagline"],
      ["about.title1", "Title line 1"],
      ["about.title2", "Title line 2"],
      ["about.hero", "Intro paragraph", true],
      ["about.p1_img", "Card 1 image (blank uses the red icon)", "image"], ["about.p1_title", "Card 1 title"], ["about.p1_desc", "Card 1 text", true], ["about.p1_url", "Card 1 link (optional, makes the card clickable)"],
      ["about.p2_img", "Card 2 image (blank uses the red icon)", "image"], ["about.p2_title", "Card 2 title"], ["about.p2_desc", "Card 2 text", true], ["about.p2_url", "Card 2 link (optional, makes the card clickable)"],
      ["about.p3_img", "Card 3 image (blank uses the red icon)", "image"], ["about.p3_title", "Card 3 title"], ["about.p3_desc", "Card 3 text", true], ["about.p3_url", "Card 3 link (optional, makes the card clickable)"],
      ["about.p4_img", "Card 4 image (blank uses the red icon)", "image"], ["about.p4_title", "Card 4 title"], ["about.p4_desc", "Card 4 text", true], ["about.p4_url", "Card 4 link (optional, makes the card clickable)"],
      ["about.rules_eyebrow", "Rules label"],
      ["about.rules_title", "Rules title"],
      ["about.rules_accent", "Rules title (red word)"],
      ["about.rule1", "Rule 1", true], ["about.rule2", "Rule 2", true],
      ["about.rule3", "Rule 3", true], ["about.rule4", "Rule 4", true],
      ["about.extra_label", "Extra section label"],
      ["about.extra", "Extra section text (blank hides it)", true],
    ],
  },
  {
    group: "Events",
    fields: [
      ["events.eyebrow", "Label"],
      ["events.title", "Title"],
      ["events.accent", "Title (red word)"],
      ["events.empty", "No events message", true],
    ],
  },
  {
    group: "Links",
    fields: [
      ["links.eyebrow", "Label"],
      ["links.title", "Title"],
      ["links.accent", "Title (red word)"],
      ["links.subtitle", "Subtitle", true],
    ],
  },
  {
    group: "Chat",
    fields: [
      ["chat.eyebrow", "Label"],
      ["chat.title", "Title"],
      ["chat.placeholder", "Message box placeholder"],
      ["chat.empty", "Empty chat message"],
    ],
  },
  {
    group: "Login",
    fields: [
      ["login.title", "Sign-in title"],
      ["login.subtitle", "Sign-in subtitle", true],
      ["login.button", "Sign-in button"],
      ["register.title", "Sign-up title"],
      ["register.subtitle", "Sign-up subtitle", true],
      ["register.button", "Sign-up button"],
    ],
  },
];

export const DEFAULT_CONTENT = {
  "nav.about": "About",
  "nav.events": "Events",
  "nav.links": "Links",
  "nav.chat": "Tavern Chat",
  "nav.enter": "Enter Tavern",
  "about.tagline": "Est. in the embers",
  "about.title1": "Ballhoot’s",
  "about.title2": "Tavern",
  "about.hero": "A gathering place for gamers, dungeon-crawlers, speedrunners and lore-chasers. Pull up a stool, drop your pack by the door, and raise a tankard to the fellowship.",
  "about.p1_title": "Hearth", "about.p1_desc": "A warm corner for weary travellers of every realm.",
  "about.p2_title": "Guild", "about.p2_desc": "Find a party, raid together, chat into the small hours.",
  "about.p3_title": "Quests", "about.p3_desc": "Weekly tabletop sessions, tournaments, and side gigs.",
  "about.p4_title": "Revelry", "about.p4_desc": "Streams, viewing parties, and the odd late-night ale.",
  "about.rules_eyebrow": "The House Rules",
  "about.rules_title": "Four laws of the",
  "about.rules_accent": "tavern",
  "about.rule1": "Respect every traveller. Everyone starts at level one somewhere.",
  "about.rule2": "Spoilers belong behind tags, not thrown across the room.",
  "about.rule3": "No cheats, no scams, no selling anything of this world or any other.",
  "about.rule4": "If you must argue, argue well, then buy the other a drink.",
  "about.extra_label": "From the Keeper",
  "about.extra": "",
  "events.eyebrow": "The Scroll",
  "events.title": "Upcoming",
  "events.accent": "Events",
  "events.empty": "No events on the board yet. The tavern-keeper is drafting the next quest.",
  "links.eyebrow": "The Noticeboard",
  "links.title": "Our",
  "links.accent": "Links",
  "links.subtitle": "Follow the fellowship across the realms.",
  "chat.eyebrow": "The Hearth",
  "chat.title": "Tavern Chat",
  "chat.placeholder": "Speak into the hearth...",
  "chat.empty": "The tavern is quiet. Be the first to speak.",
  "login.title": "Enter the Tavern",
  "login.subtitle": "Return to the hearth. Resume your quests, join the chat.",
  "login.button": "Step Inside",
  "register.title": "Reserve a Seat",
  "register.subtitle": "Claim your name at the gathering. All are welcome.",
  "register.button": "Join the Tavern",
};
